import type { ButtonHTMLAttributes, PropsWithChildren } from 'react'
import { Link } from '../lib/router'

type Props = PropsWithChildren<{
  variant?: 'primary' | 'secondary'
  to?: string
  className?: string
}> &
  ButtonHTMLAttributes<HTMLButtonElement>

export function Button({
  children,
  variant = 'primary',
  to,
  className = '',
  ...buttonProps
}: Props) {
  const classes = `button button--${variant} ${className}`.trim()
  if (to) {
    return (
      <Link className={classes} to={to}>
        {children}
      </Link>
    )
  }
  return (
    <button className={classes} {...buttonProps}>
      {children}
    </button>
  )
}
